import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import FootballState from "../state/football-state";
import { FragmentMessages } from "../../common/fragment-messages";

/**
 * Rebound Net caught by defense fragment for Indoor Football.
 * When the ball hits the rebound net and is caught by the defensive team.
 * This changes possession.
 */
export default class ReboundNetCaughtDefense extends Fragment {
    constructor(caughtBy, caughtAt) {
        super();
        this.code = "RBNCD";
        this.caughtBy = caughtBy;
        this.caughtAt = caughtAt;

        this.requiredData = [
            {
                name: "caughtBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Caught By",
                title: (team) => `Caught By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "caughtAt",
                type: FragmentDataType.FieldPosition,
                displayName: "At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                requiredAfterNextState: [
                    FootballState.Tackle,
                    FootballState.OutOfBounds
                ]
            }
        ];
    }

    changesPossession() {
        return true;
    }

    getFieldPosition() {
        return this.caughtAt;
    }

    getPlayers() {
        return [this.caughtBy];
    }

    getFragmentTeamId() {
        return this.caughtBy?.teamId;
    }

    summarize(summaryContext, stringifier) {
        const message = `caught by ${stringifier.firstInitial(this.caughtBy)}`;
        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.homeTeamHasPossession =
            this.caughtBy?.teamId === summaryContext.homeTeamId;
        if (this.caughtAt || this.caughtAt === 0) {
            summaryContext.fieldPosition = this.caughtAt;
        }
        summaryContext.playerInPossession = this.caughtBy;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            caughtBy: playerReducer(this.caughtBy)
        };
    }
}
